import {TERMS_CONDITIONS} from '../actions/types';

const INTIAL_STATE = [];

export default (state = INTIAL_STATE,action) => {
    switch(action.type){
        case TERMS_CONDITIONS:
            return action.payload;
        default:
            return state;
    }
}